import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs';
import { IHoliday } from '../model/holiday';
import { HolidayService } from '../services/holiday.service';

@Component({
    selector: 'app-holiday-grid',
    templateUrl: './holiday-grid.component.html',
    styleUrls: ['./holiday-grid.component.css'],
    standalone: false
})
export class HolidayGridComponent implements OnInit {

  constructor(
    private route : ActivatedRoute,
    private holidayService: HolidayService
  ) { }

  holidays: IHoliday [] = [];
  public formGroup!: UntypedFormGroup;
  private editedRowIndex!: number;

  ngOnInit(): void {
    this.holidays = this.route.snapshot.data.holidays as IHoliday[];
  }

  updateList(){
    this.holidayService.searchHolidays({pageNumber: 0, pageSize: 999999})
    .pipe(first())
    .subscribe(response => {
      this.holidays = response.data;
    })
  }

  addHandler({ sender }){
    this.closeEditor(sender);

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(null, Validators.required),
      start: new UntypedFormControl(null, Validators.required),
      end: new UntypedFormControl(null),
      isAlwaysSameDate: new UntypedFormControl(false),
      isPreworked: new UntypedFormControl(false),
      isAllDay: new UntypedFormControl(true),
    });

    sender.addRow(this.formGroup);
  }

  editHandler({ sender, rowIndex, dataItem }){
    this.closeEditor(sender);

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(dataItem.name, Validators.required),
      start: new UntypedFormControl(new Date(dataItem.start), Validators.required),
      end: new UntypedFormControl(new Date(dataItem.end)),
      isAlwaysSameDate: new UntypedFormControl(dataItem.isAlwaysSameDate),
      isPreworked: new UntypedFormControl(dataItem.isPreworked),
      isAllDay: new UntypedFormControl(dataItem.isAllDay),
    });

    this.editedRowIndex = rowIndex;

    sender.editRow(rowIndex, this.formGroup);
  }

  public cancelHandler({ sender, rowIndex }) {
    this.closeEditor(sender, rowIndex);
  }

  public saveHandler(event) {
    const request: any = {
      name: event.formGroup.value.name,
      start: new Date(event.formGroup.value.start).toDateString(),
      end: new Date(event.formGroup.value.start).toDateString(),
      isAlwaysSameDate: event.formGroup.value.isAlwaysSameDate,
      isPreworked: event.formGroup.value.isPreworked,
      isAllDay: event.formGroup.value.isAllDay,
      id: event.dataItem.id ?? null,
    }
    if (!event.dataItem.id){
      this.holidayService.createHoliday(request)
      .subscribe(response => {
        this.updateList();
      });
    } else {
      this.holidayService.updateHoliday(request)
      .subscribe(response => {
        this.updateList();
      });;
    }

    event.sender.closeRow(event.rowIndex);
    
  }

  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }

  deletionDialogOpened = false;
  private itemToDelete: { id: string } | null = null;

  public removeHandler({ dataItem }) {
    this.itemToDelete = dataItem;
    this.deletionDialogOpened = true;
  }

  public deleteConfirmed() {
    const dataItem = this.itemToDelete;
    this.itemToDelete = null;
    if (!dataItem) return;
    this.holidayService.deleteHoliday(dataItem.id)
    .subscribe(response => {
      this.updateList();
    });;
  }

}
